module.exports = __webpack_public_path__ + "static/gallery_yarra_1-3dc9604a9f6edb6e0a8fe23194cacca5.jpg";